import { z } from 'zod';
import type { AwardTypeCode } from '../types.js';

/** Employee is represented by Everyone; the other selectors are existing roles, not new grants. */
export const RECOGNIZE_ROLES = [
  'manager',
  'sector_lead',
  'delegate',
  'executive_delegate',
  // Saved audiences still say it; it reads as the Executives' delegates (APP-274).
  'requester',
  'executive',
  'stock_admin',
  'payroll',
  'finance',
  'system_admin',
  'paa_taa_approver',
  'spot_reviewer',
] as const;
export type RecognizeRole = (typeof RECOGNIZE_ROLES)[number];
export const RecognizeAudienceSchema = z
  .object({
    everyone: z.boolean(),
    roles: z
      .array(z.enum(RECOGNIZE_ROLES))
      .max(RECOGNIZE_ROLES.length)
      .refine((v) => new Set(v).size === v.length),
    personIds: z
      .array(z.uuid().transform((v) => v.toLowerCase()))
      .max(500)
      .refine((v) => new Set(v).size === v.length),
  })
  .strict();
export type RecognizeAudience = z.infer<typeof RecognizeAudienceSchema>;
export interface RecognizePolicy {
  readonly enabled: boolean;
  /** A malformed persisted value must deny initiation, never restore a permissive default. */
  readonly audience: unknown;
}
export type RecognizePolicies = Readonly<Partial<Record<AwardTypeCode, RecognizePolicy>>>;
export function defaultRecognizeAudience(type: AwardTypeCode): RecognizeAudience {
  return {
    everyone: type === 'SPOT',
    // APP-275: Executives start every award type; a System Admin can still take them out.
    roles:
      type === 'SPOT'
        ? []
        : type === 'EDB'
          ? ['executive', 'requester']
          : ['sector_lead', 'executive'],
    personIds: [],
  };
}
